import { useEffect } from 'react';
import type { UseFormReturn } from 'react-hook-form';

export function useScrollToFirstError(form: UseFormReturn<any>, formId: string): void {
	const { submitCount, errors } = form.formState;

	useEffect(() => {
		if (submitCount === 0) return;
		if (Object.keys(errors).length === 0) return;

		const formEl = document.getElementById(formId);
		const firstInvalid = formEl?.querySelector<HTMLElement>('[aria-invalid="true"]');

		if (firstInvalid) {
			firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
			firstInvalid.focus({ preventScroll: true });
		} else {
			const firstErrorName = Object.keys(errors)[0];
			if (firstErrorName) {
				form.setFocus(firstErrorName);
			}
		}
		// intentionally omit errors from deps — only scroll once per submit attempt
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [submitCount]);
}
